import { useState } from "react";
import { ImageLightbox } from "./ImageLightbox";

export function ImageCarousel({ urls }: { urls: string[] }) {
  const [idx, setIdx] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  if (urls.length === 0) return null;
  return (
    <div className="relative mb-5 aspect-[4/3] w-full overflow-hidden rounded-row border border-line bg-black">
      {/* The frame is letterboxed to 4:3 while a card is 2.5:3.5, so what is on
          screen here is a fraction of the pixels the scan actually holds. Tapping
          it hands over the rest. */}
      <button type="button" onClick={() => setZoomed(true)} className="block h-full w-full" aria-label="View larger">
        <img src={urls[idx]} alt={`Card ${idx + 1}`} className="h-full w-full object-contain" />
      </button>
      {zoomed && <ImageLightbox urls={urls} startIndex={idx} onClose={() => setZoomed(false)} />}
      {urls.length > 1 && (
        <>
          <button
            type="button"
            onClick={() => setIdx((i) => (i - 1 + urls.length) % urls.length)}
            className="absolute left-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 text-lg leading-none text-white"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={() => setIdx((i) => (i + 1) % urls.length)}
            className="absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-black/60 text-lg leading-none text-white"
          >
            ›
          </button>
          <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
            {urls.map((url, i) => (
              <div key={url} className={`h-2 w-2 rounded-full ${i === idx ? "bg-accent" : "bg-white/40"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
